// extracted by mini-css-extract-plugin
export default {"list":"List_list__FCuK1","loading":"List_loading__oZDCh","error":"List_error__SrUUQ","noResults":"List_noResults__SJ6-A"};